import React from 'react';

const escapeRegExp = (str: string) => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

interface MatchStringProps {
  matchedSubstrings: { length: number; offset: number };
  mainText: string;
}

const MatchString = ({ matchedSubstrings, mainText }: MatchStringProps) => {
  const match = mainText.substring(
    matchedSubstrings.offset,
    matchedSubstrings.offset + matchedSubstrings.length
  );
  const regEx = new RegExp(`(${escapeRegExp(match)})+`, 'g');
  return (
    <div className="match">
      {regEx &&
        mainText.split(regEx).map((str, key) => (
          <span key={key} className={str === match ? 'bold' : ''}>
            {str}
          </span>
        ))}
    </div>
  );
};

export default MatchString;
